import { useEffect, useRef } from 'react';

function useViewTracking(hasViewed, onView, options = {}) {
  const { threshold = 0.5, delay = 2000, root = null } = options;

  const elementRef = useRef(null);
  const onViewRef = useRef(onView);

  useEffect(() => {
    onViewRef.current = onView;
  });

  useEffect(() => {
    if (!elementRef.current || hasViewed) return () => {};

    let timer = null;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (timer) {
          clearTimeout(timer);
          timer = null;
        }

        if (entry.isIntersecting) {
          timer = setTimeout(() => {
            onViewRef.current?.();
          }, delay);
        }
      },
      { threshold, root },
    );

    observer.observe(elementRef.current);

    return () => {
      observer.disconnect();
      if (timer) {
        clearTimeout(timer);
      }
    };
  }, [hasViewed, threshold, delay, root]);

  return elementRef;
}

export default useViewTracking;
